import(/* webpackMode: "eager" */ "/workspace/src/app/faq/page.tsx");
